module.exports = __webpack_public_path__ + "static/media/placeholder.f4803871.jpg";